/**
 * City and HQ zone types for the Legendary Arena game engine.
 *
 * The City is a row of spaces (5 by default; 1-6 under a scheme that changes
 * the number of city spaces, WP-831 / D-24764) where revealed villains and
 * henchmen are placed. The HQ is a row of 5 hero slots for recruit-eligible
 * heroes and stays a fixed 5-tuple.
 *
 * No boardgame.io imports. No registry imports. Types and the City size bounds only.
 */
/** The City size every match starts with (rules v23: "Each of the 5 city spaces"). */
export const CITY_DEFAULT_SIZE = 5;
/** The fewest city spaces a scheme can leave (Change the Outcome of WWII: Switzerland, 1). */
export const CITY_MIN_SIZE = 1;
/** The most city spaces a scheme can make (Change the Outcome of WWII: USSR, 6). */
export const CITY_MAX_SIZE = 6;
//# sourceMappingURL=city.types.js.map